import io from 'socket.io-client'
import config from '@/config/app-cfg'

// Use the same API URL as the rest of the app (without /api path if present)
const socketUrl = config.API_URL.replace(/\/api\/?$/, '')

console.log('🚀 [OnlineListner] Script executed at top level.')

/**
 * Connectivity Status Enum
 */
export const Connectivity = {
  ONLINE: 'online',
  SERVER_OFFLINE: 'serverOffline',
  CLIENT_OFFLINE: 'clientOffline'
}

window.Connectivity = Connectivity

let socket = null
let lastStatus = null

try {
  socket = io(socketUrl, {
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    autoConnect: true
  })
} catch (err) {
  console.error('❌ [OnlineListner] Socket error:', err)
}

/**
 * Global function to get current connectivity status
 */
window.onlineListener = function () {
  if (!window.navigator.onLine) {
    return Connectivity.CLIENT_OFFLINE
  }
  if (!socket || !socket.connected) {
    return Connectivity.SERVER_OFFLINE
  }
  return Connectivity.ONLINE
}

/**
 * Dispatch a CustomEvent 'onlineListener' on the window only if status changed
 */
const dispatchConnectivityEvent = (force = false) => {
  try {
    const status = window.onlineListener()

    // Only dispatch if status has changed OR if forced
    if (!force && status === lastStatus) {
      return
    }

    lastStatus = status
    const event = new CustomEvent('onlineListener', {
      detail: status,
      bubbles: true,
      cancelable: true
    })

    window.dispatchEvent(event)
    console.log(`📢 [OnlineListner] Status Changed & Dispatched: ${status}`)
  } catch (err) {
    console.error('❌ [OnlineListner] Dispatch error:', err)
  }
}

if (socket) {
  socket.on('connect', () => {
    console.log('✅ [OnlineListner] Connected Event')
    dispatchConnectivityEvent()
  })

  socket.on('disconnect', () => {
    console.log('❌ [OnlineListner] Disconnected Event')
    dispatchConnectivityEvent()
  })

  socket.on('connect_error', (error) => {
    console.error('❌ [OnlineListner] Socket Error:', error.message)
    dispatchConnectivityEvent()
  })
}

/**
 * Browser Network Listeners
 */
window.addEventListener('online', () => {
  console.log('🌐 [OnlineListner] Browser Online')
  if (socket && !socket.connected) {
    socket.connect()
  }
  dispatchConnectivityEvent()
})

window.addEventListener('offline', () => {
  console.log('🔌 [OnlineListner] Browser Offline')
  dispatchConnectivityEvent()
})

// Periodic check for status changes (silent unless changed)
setInterval(() => {
  dispatchConnectivityEvent()
}, 3000)

// Initial dispatch (forced)
setTimeout(() => {
  dispatchConnectivityEvent(true)
}, 1500)

// Helper for manual trigger
window.testOnline = () => {
  console.log('🧪 [Manual Test] Forcing dispatchConnectivityEvent...')
  dispatchConnectivityEvent(true)
}

export default socket



// WEBPACK FOOTER //
// ./src/utils/OnlineListner.js